import { Stack, Typography } from '@mui/material';
import TablePageContainer from 'components/TablePageContainer';
import useMobileBreakpoint from 'hooks/useMobileBreakpoint';
import Disclaimer from 'pages/headliner/components/Disclaimer';
import StatsSummary from 'pages/headliner/SocialStatsSummary';
import React from 'react';
import { Stats } from '../types';
import * as S from './styles';

type TableContainerProps = {
  title: React.ReactNode;
  children: React.ReactNode;
  youTubeStats?: Stats;
  socialStats?: Stats;
};

const TableContainer: React.FC<TableContainerProps> = ({
  title,
  youTubeStats,
  socialStats,
  children,
}) => {
  const isMobile = useMobileBreakpoint('md');
  return (
    <TablePageContainer>
      {title}
      <S.Container direction={isMobile ? 'column' : 'row'}>
        {youTubeStats && (
          <StatsSummary title="YouTube Overview" stats={youTubeStats} />
        )}
        {socialStats && (
          <StatsSummary stats={socialStats} title="Social platforms overview" />
        )}
      </S.Container>
      <Stack spacing={1} marginTop={3}>
        <Typography variant="h3">Video breakdown</Typography>
        {children}
        <Disclaimer />
      </Stack>
    </TablePageContainer>
  );
};
export default TableContainer;
